export default Object.freeze({
  Queued: 1,
  InProgress: 2,
  Completed: 3,
  RequiresAction: 4,
  Expired: 5,
  Cancelling: 6,
  Cancelled: 7,
  Failed: 8,
  Incomplete: 9,
});
